import React, { useEffect, useState } from 'react';
import { getPassword, storePassword } from '../helpers/storageHelper';
import { AxiosHelper } from '../helpers/axiosHelper';
import useLogin from '../hooks/useLogin';
import { useNavigate } from 'react-router-dom';
const Login = () => {
  const navigate = useNavigate();

  const { login } = useLogin();
  useEffect(() => {
    const password = getPassword();
    if (password) {
      AxiosHelper.setUpAxios(password);
      navigate('/');
    }
  }, []);
  const [password, setPassword] = useState('');
  const loginButton = async () => {
    AxiosHelper.setUpAxios(password);
    const success = await login();
    if (success) {
      storePassword(password);
      navigate('/');
    } else {
      alert('Password incorrect! Try again');
    }
  };
  return (
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
          Sign in to Student Tracker
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <div>
          <div className="flex items-center justify-between">
            <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
              Password
            </label>
          </div>
          <div className="mt-2">
            <input
              type="password"
              name="password"
              id="password"
              autoComplete="current-password"
              required
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 border mb-8"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>

        <div>
          <button
            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={loginButton}
          >
            Sign in
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
